import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { SelectInput } from "../../components/inputs/Inputs";
import { Controller } from "react-hook-form";

export const TarifaSelectionSection = ({
    control,
    errors,
    setValue,
    loading, //Bloquea inputs y muestra estados de carga
    tarifas, //Lista de tarifas comerciales disponibles para select
    disableTF, //Flag para deshabilitar tarifa_comercial si todavía no toca elegirla
    tarifasOferta, //Opciones de tarifa de acceso (ATR) según sector
    sectorType,
    prefillModeValue,
    prefillModeLabel,
    prefillTarifaValue,
    prefillTarifaLabel,
    readOnly = {} , // New prop: { mode_facturacio: bool, tarifa_oferta: bool, tarifa_comercial: bool }
    user,
    isSuperAdmin = false,
}) => {
    const isRestrictedCallAgent = Boolean(user?.is_call_agent && !isSuperAdmin);

    useEffect(() => {
        // Si és call agent, forcem el valor a indexada per evitar canvis de tipus de tarifa.
        if (isRestrictedCallAgent) {
            setValue("mode_facturacio", "index");
        }
    }, [isRestrictedCallAgent, setValue]);

    return (
    <div className="bg-light p-4 rounded-4 border border-light mb-4">
        <Row className="g-3">
            {/* Configuracion Tipo de tarifa */}
            <Col md={6}>
                <Controller
                    control={control}
                    name="mode_facturacio"
                    render={({ field }) => (
                        <div>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Tipo de tarifa</label>
                            {(() => {
                                const normalizedValue =
                                    field.value === null || field.value === undefined || field.value === ""
                                        ? String(prefillModeValue || "")
                                        : String(field.value);
                                const hasKnownOption = ["index", "atr"].includes(normalizedValue);
                                const fallbackLabel = prefillModeLabel || normalizedValue;

                                return (
                                    <SelectInput
                                        {...field}
                                        value={normalizedValue}
                                        noFloating={true}
                                        error={errors.mode_facturacio?.message}
                                        className="bg-white shadow-sm"
                                        disabled={loading}
                                        style={{
                                            pointerEvents: readOnly.mode_facturacio ? "none" : "auto",
                                            opacity: readOnly.mode_facturacio ? 0.8 : 1,
                                            backgroundColor: readOnly.mode_facturacio ? "#e9ecef" : "#fff",
                                        }}
                                        onChange={(e) => {
                                            const nuevo = e.target.value;
                                            if (String(field.value ?? "") !== nuevo) {
                                                field.onChange(nuevo);
                                                setValue("tarifa_comercial", "");
                                            }
                                        }}
                                    >
                                        <option key="null" value=""></option>
                                        <option key="index" value="index">Indexada</option>
                                        {!isRestrictedCallAgent && <option key="fijo" value="atr">Fijo</option>}
                                        {normalizedValue && !hasKnownOption && (
                                            <option value={normalizedValue}>{fallbackLabel}</option>
                                        )}
                                    </SelectInput>
                                );
                            })()}
                        </div>
                    )}
                />
            </Col>
            {/* Configuracion Tarifa de acceso */}
            {/* 
                export const TARIFAS_OFERTA = {
                    electrico: [
                        { id: 41, name: "2.0TD", key: "20" },
                        { id: 42, name: "3.0TD", key: "30" },
                        { id: 43, name: "6.1TD", key: "6" },
                    ],
                    gas: [
                        { id: 11, name: "RL01", key: "RL01" },
                        { id: 12, name: "RL02", key: "RL02" },
                        { id: 13, name: "RL03", key: "RL03" },
                        { id: 14, name: "RL04", key: "RL04" },
                        { id: 22, name: "RLTB5", key: "RLTB5" },
                    ]
                };
            */}
            <Col md={6}>
                <Controller
                    control={control}
                    name="tarifa_oferta"
                    render={({ field }) => (
                        <div>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Tarifa de acceso</label>
                            {(() => {
                                const normalizedValue = field.value === null || field.value === ""
                                        ? String(prefillTarifaValue || "")
                                        : String(field.value);
                                // Perfil call, per a la tarifa d'accés:
                                // - en llum només es permet 2.0TD,
                                // - en gas només es permeten RL01 i RL02,
                                // i en altres casos es mostren totes les opcions disponibles.
                                const filteredTarifasOferta = Array.isArray(tarifasOferta)? tarifasOferta.filter((tarifa) => {
                                // Si no és CALL Agent, retorna true per totes les tarifes    
                                // Si es CALL Agent, si es gas accepta RL01 i RL02, i si es llum accepta 2.0TD
                                        if (!isRestrictedCallAgent) return true;
                                        const name = String(tarifa?.name || "").toUpperCase();
                                        return sectorType === "gas"
                                            ? ["RL01", "RL02"].includes(name)
                                            : name.includes("2.0TD");
                                    }) : [];
                                const hasKnownOption = filteredTarifasOferta.some((tarifa) => String(tarifa.id) === normalizedValue);
                                const fallbackLabel = prefillTarifaLabel || normalizedValue;

                                return (
                                    <SelectInput
                                        {...field}
                                        value={normalizedValue}
                                        noFloating={true}
                                        error={errors.tarifa_oferta?.message}
                                        className="bg-white shadow-sm"
                                        disabled={loading}
                                        style={{
                                            pointerEvents: readOnly.tarifa_oferta ? "none" : "auto",
                                            opacity: readOnly.tarifa_oferta ? 0.8 : 1,
                                            backgroundColor: readOnly.tarifa_oferta ? "#e9ecef" : "#fff",
                                        }}
                                        onChange={(e) => {
                                            const nuevo = e.target.value;
                                            if (String(field.value ?? "") !== nuevo) {
                                                field.onChange(nuevo);
                                                setValue("tarifa_comercial", "");
                                            }
                                        }}
                                    >
                                        <option key="null" value="" disabled></option>
                                        {filteredTarifasOferta.length > 0 ? (
                                            filteredTarifasOferta.map((tarifa) => (
                                                <option key={tarifa.id} value={String(tarifa.id)}>{tarifa.name}</option>
                                            ))
                                        ) : (
                                            <option disabled>No hay tarifas de acceso</option>
                                        )}
                                        {normalizedValue && !hasKnownOption && (
                                            <option value={normalizedValue}>{fallbackLabel}</option>
                                        )}
                                    </SelectInput>
                                );
                            })()}
                        </div>
                    )}
                />

            </Col>
            {/* Configuracion Tarifas comerciales */}
            <Col md={12}>
                <div className="d-flex align-items-center gap-2">
                    <div className="flex-grow-1">
                        <Controller
                            control={control}
                            name="tarifa_comercial"
                            render={({ field }) => (
                                <div>
                                    <label className="text-muted small fw-bold text-uppercase mb-2">Tarifas comerciales</label>
                                    <SelectInput
                                        {...field}
                                        noFloating={true}
                                        error={errors.tarifa_comercial?.message}
                                        disabled={disableTF || loading || readOnly.tarifa_comercial}
                                        className="bg-white shadow-sm"
                                    >
                                        {loading ? (
                                            <option>Cargando tarifas...</option>
                                        ) : (
                                            tarifas?.map((tarifa) => (
                                                <option key={tarifa.id} value={tarifa.id}>
                                                    {tarifa.name}
                                                </option>
                                            ))
                                        )}
                                    </SelectInput>
                                </div>
                            )}
                        />
                    </div>
                    {loading && (
                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    )}
                </div>
            </Col>
        </Row>
    </div>
);};